import Swiper from 'swiper/bundle';

class CustomLightbox {
  wrapper = null;

  constructor(el) {
    this.wrapper = $(el);

    if (this.wrapper.length) {
      //this.gallery();
      this.load();
      this.events();
    }
  };

  load() {
    // Request lightbox
    $.ajax({
      url: ajaxurl,
      data: {
        action: 'lightbox',
      },
      type: 'POST',
      dataType: 'JSON',
    }).done((response) => {
      $('.main').append(response);
      CustomLightbox.el = $('#lightbox');
      CustomLightbox.slider_dom = CustomLightbox.el.find('.lightbox-slider');
    });
  }

  events() {
    // Close on X click
    $('body').on('click', '.lightbox-close', (e) => {
      e.preventDefault();
      this.close();
    });

    // Close on ESC key
    $(document).keyup((e) => {
      if (e.keyCode === 27) {
        this.close();
      }
    });

    // Close if clicked outside of image
    $('body').on('click', '.lightbox-body', (e) => {
      var container = CustomLightbox.el.find('.lightbox-container');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        this.close();
      }
    });

    // Expand image on click
    $('body').on('click', '.product-item__images--item', (e) => {
      var galleryEl = $(e.currentTarget).parent();
      var item = $(e.currentTarget).attr('data-item');
      this.open(galleryEl, item);
    });

    // Expand image on Expand click
    $('body').on('click', '.gallery__expand', (e) => {
      e.preventDefault();
      var galleryEl = $(this).closest('.product-item__images');
      var item = e.currentTarget().data('item');
      this.open(galleryEl, item);
    });
  }

  gallery() {
    $('.gallery--slider').each(function (index) {
      const galleryEl = $(this);
      const sliderEl = galleryEl.find('.gallery__slider');

      const thumbsEl = galleryEl.find('.thumbs__slider');

      if (thumbsEl.length) {
        var galleryThumbs = new Swiper(thumbsEl[0], {
          //modules: [Lazy],
          spaceBetween: 10,
          slidesPerView: 4,
          loop: false,
          freeMode: false,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
          },
          on: {
            init() {
              thumbsEl.addClass('thumbs__slider--loaded');
            },
          },
        });
      } else {
        var galleryThumbs = false;
      }

      // Init content slider
      const nav_prev = galleryEl.find('.swiper-button-prev');
      const nav_next = galleryEl.find('.swiper-button-next');

      new Swiper(sliderEl[0], {
        //modules: [Lazy, Navigation, Pagination, Thumbs],
        loop: thumbsEl.length ? false : true,
        slidesPerView: 1,
        spaceBetween: 35,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        navigation: {
          prevEl: nav_prev[0],
          nextEl: nav_next[0],
        },
        pagination: {
          el: galleryEl.find('.swiper-pagination')[0],
          clickable: true,
          type: 'bullets',
        },
        thumbs: {
          swiper: galleryThumbs,
        },
        on: {
          init() {
            sliderEl.addClass('gallery__slider--loaded');
          },
        },
      });
    });
  }

  close() {
    // Destroy slider
    if (lightbox.slider) {
      CustomLightbox.slider.destroy();
    }
    // Remove lightbox
    CustomLightbox.el.removeClass('lightbox--open');
    // Allow scroll
    $('html').removeClass('no-scroll');
  }

  open(galleryEl, item) {
    if (!lightbox.loading) {
      CustomLightbox.loading = true;

      // Disable scroll
      $('html').addClass('no-scroll');
      CustomLightbox.el.addClass('lightbox--loading');

      // Adds slides to slider
      var images = galleryEl.attr('data-ids').split(',').map(Number);
      $.ajax({
        url: ajaxurl,
        data: {
          action: 'lightbox_load_images',
          images: images,
        },
        type: 'POST',
      }).done((response) => {
        if (response.success) {
          CustomLightbox.el.find('.lightbox-wrapper').html(response.data);
          CustomLightbox.el.find('.thumbs-wrapper').html(response.data);
          // Load swiper on lightbox
          this.construct(galleryEl, item);
        }
      });
    }
  }

  construct(galleryEl, item) {
    let number = parseInt(item) - 1;

    // Init slider
    var nav_prev = CustomLightbox.el.find('.swiper-button-prev');
    var nav_next = CustomLightbox.el.find('.swiper-button-next');

    var thumbsSwiper = new Swiper(".thumbsswiper", {
      //modules: [Lazy],
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
        1200: {
          slidesPerView: 6,
        },
      },
    });


    new Swiper(CustomLightbox.slider_dom[0], {
      //modules: [Lazy, Navigation, Thumbs],
      initialSlide: number,
      loop: true,
      thumbs: {
        swiper: thumbsSwiper,
      },
      zoom: {
        maxRatio: 3,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
        prevEl: nav_prev[0],
        nextEl: nav_next[0],
      },
      on: {
        init() {
          // Open lightbox
          CustomLightbox.el.removeClass('lightbox--loading');
          CustomLightbox.el.addClass('lightbox--open');
          CustomLightbox.loading = false;
        },
      },
    });

    const sliderEl = galleryEl.find('.gallery__slider');
    if (sliderEl.length && sliderEl[0].swiper) {
      CustomLightbox.slider.on('slideChange', function () {
        // Sync with content
        var slide_to = this.realIndex;
        sliderEl[0].swiper.slideToLoop(slide_to);
      });
    }
  }

}

export default CustomLightbox;
